import { Grid2, Box, Typography, Button } from '@mui/material';
import React from 'react';
import './AboutUs.css';
import { useNavigate } from 'react-router-dom';

const AboutUs: React.FC = () => {
    const navigate = useNavigate();
    
    return (
        <Box className="main-AboutUs">
            <Grid2
                container
                // spacing={{xs: 1, md: 2}}
                justifyContent="center"
                alignItems="center"
                className="about-us-Grid2"
                columns={{xs: 10}}
                size={{xs:10}}
            >
                <Grid2
                        container
                        justifyContent="center"
                        alignItems="center"
                       className="parent"
                       size={{xs: 9}}
                       spacing={{xs: 5, md: 5}}
                >
                    <Box className='ellipse'></Box>
                    <Grid2 size={{xs: 10, md: 8}} id={'aboutUdM'}>
                        <Typography className="h1" align="center">
                            About Us
                        </Typography>
                    </Grid2>
                    <Grid2 size={{xs: 10, md: 8}} >
                        <Typography className="txt" align="center">
                            At 8RABBITS, we redefine online casino gaming with innovative twists
                            on classic games that keep players coming back. Led by industry
                            veterans, we combine cutting-edge design and player insights to
                            create thrilling, market-leading experiences. Whether attracting
                            new players or boosting loyalty, 8RABBITS helps build a standout
                            gaming library. Elevate your offerings with 8RABBITS—where
                            innovation meets player engagement.
                        </Typography>
                    </Grid2>
                    <Grid2 size={{xs: 10, md: 10   }} textAlign="center">
                        <Button className="btn" onClick={() => navigate('/aboutUs')}>
                            Read More
                            <svg
                                width="14"
                                height="15"
                                viewBox="0 0 14 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    id="Arrow 1"
                                    d="M0.508419 13.0253C0.230148 13.3321 0.253291 13.8064 0.56011 14.0847C0.86693 14.3629 1.34124 14.3398 1.61951 14.033L0.508419 13.0253ZM12.7493 1.43439C12.7291 1.02067 12.3773 0.701651 11.9636 0.721837L5.22164 1.0508C4.80792 1.07098 4.4889 1.42274 4.50908 1.83646C4.52927 2.25018 4.88102 2.5692 5.29474 2.54902L11.2876 2.25661L11.58 8.24948C11.6002 8.6632 11.952 8.98222 12.3657 8.96203C12.7794 8.94185 13.0984 8.5901 13.0782 8.17637L12.7493 1.43439ZM1.61951 14.033L12.5557 1.9748L11.4446 0.967092L0.508419 13.0253L1.61951 14.033Z"
                                    fill="black"
                                />
                            </svg>
                        </Button>
                    </Grid2>
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default AboutUs;